import React, {
    ReactElement,
} from "react";
import DisplayUserGroup from "../../../../components/creators/user-groups/UserGroups";
import SettingsContainer from "../../../../components/theme/settings";
import useArticleContext from "../../../../contexts/HelpContext";
import useRouting, { Paths, useParams } from "../../../../contexts/Routing";
import TokensTable from "./TokensTable";
import UserTable from "./UsersTable";

function DisplayList(): ReactElement {
    const { historyPush } = useRouting();
    const { setting } = useParams(Paths.ADMINISTRATOR_SETTING);

    return (
        <SettingsContainer
            navigation="tabs"
            selectedSectionKey={setting}
            onSectionChanged={key => historyPush(Paths.ADMINISTRATOR_SETTING, { setting: key })}
        >
            <UserTable />
            <TokensTable />

        </SettingsContainer>
    );
}

export default function UsersSettings(): ReactElement {
    const { historyPush } = useRouting();
    useArticleContext("urn:fq:article:31a8fea042ce453c8dcf04b38a3f6ed6");

    const { id } = useParams(Paths.ADMINISTRATOR_SETTING_ID);
    return id ? (
        <DisplayUserGroup
            id={id}
            canDelete
            className="border p-3 rounded mb-4 bg-white"
            onDeleted={() => {
                historyPush(Paths.ADMINISTRATOR_SETTING, {
                    setting: "user-groups",
                });
            }}
            onSave={() => {
                historyPush(Paths.ADMINISTRATOR_SETTING, {
                    setting: "user-groups",
                });
            }}
        />
    ) : <DisplayList />;
}
